var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('el-input',{attrs:{"placeholder":"请输入订单号"},on:{"input":_vm.sendOrderNum},model:{value:(_vm.orderNum),callback:function ($$v) {_vm.orderNum=$$v},expression:"orderNum"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }